import { CompanyFilter } from "../../legacy/types/companyFilter";
import { MatchFileConfig } from "../../types/workspace";

export enum EXPORT_DATA_TYPES {
  INSTALL = "Product Installs",
  INTENT = "Intent Activity",
  BUYER_INTENT = "Buyer Intent",
  CONTRACTS = "Contracts",
  FAI = "Functional Area Intelligence data",
  SPEND = "Spend data",
  AI_SPEND = "AI Spend data",
  MENTIONS = "Mentions",
  MENTION_TIME_SERIES = "Mention Time Series data",
  RELATIVE_SPEND = "Relative Spend data",
  TIME_SERIES = "Time Series data",
}

export enum EXPORT_RELATED_FILTERS {
  PRODUCTS = "Product",
  INTENT = "Intent",
  BUYER_INTENT = "Buyer Intent",
  CONTRACTS = "Contracts",
}

export enum EXPORT_INCLUSION_TYPES {
  FILTERS = "FILTERS",
  ALL = "ALL",
  NONE = "NONE",
  SELECTED = "SELECTED",
  SELECTED_COLLECTIONS = "SELECTED_COLLECTIONS",
}

export enum AI_SPEND_INCLUSION_TYPES {
  NONE = "NONE",
  ABSOLUTE = "ABSOLUTE",
  RELATIVE = "RELATIVE",
  BOTH = "BOTH",
}

export enum EXPORT_FIELDS_INCLUSION_TYPES {
  ALL = "ALL",
  SELECTED = "SELECTED",
  NONE = "NONE",
}

export interface ExportFieldConfiguration {
  inclusionType: EXPORT_FIELDS_INCLUSION_TYPES;
  fields: string[];
  firmographicsInclusionType?: EXPORT_FIELDS_INCLUSION_TYPES;
  firmographicsFields?: string[];
}

export interface ExtraSearchFilters {
  departmentIds?: string[];
  roleIds?: string[];
  includeDecisionMakersAndInfluencersOnly?: boolean;
}

export interface ExportPayload {
  exportType: string;
  format: string;
  profile: {
    email: string;
    oktaUserId: string;
  };
  frontendDomain?: string;
  params: {
    searchParams: {
      sort: Array<{
        field: string;
        direction: string;
      }>;
      filters: CompanyFilter;
      scoringProfiles: unknown[];
      localizeInstalls: boolean;
      isPlatformPermissible: boolean;
      isV0Dataset: boolean;
      isV1Dataset: boolean;
      rgifExclusiveCompany: boolean;
      version: number;
      companyMatchFile?: MatchFileConfig;
      model_scores?: Array<{
        model_id: string;
        name?: string;
        columns: string[];
      }>;
      model_score_filter?: Array<{
        model_id: string;
        column: string;
        min?: number;
        max?: number;
        eq?: string;
        in?: string[];
      }>;
      tenant_id?: string;
    };
    version: number;
    title: string;
    installInclusion: string;
    installProductIds?: number[];
    timeSeriesInclusion: string;
    intentInclusion: string;
    topicIds?: string[];
    intentSignalScore?: "HIGH" | "MEDIUM" | null;
    faiInclusion: string;
    faiProductIds?: number[];
    includeDecisionMakersAndInfluencersOnly?: boolean;
    contractsInclusion: string;
    mentionInclusion: string;
    mentionTimeSeriesInclusion: string;
    spendInclusion: string;
    aiSpendInclusion: string;
    relativeSpendInclusion: string;
    generativeAIInclusion: string;
    rowBasedSpendInclusion: string;
    columns: {
      spend: {
        productPresence: unknown[];
        vendorPresence: unknown[];
      };
    };
    isCloudMaturityEnabled: boolean;
    enableFetchDataFromS3: boolean;
    enableUseHermesApi: boolean;
    enableNewFaiSheet: boolean;
  };
  scope: string;
}
